export default __webpack_public_path__ + "static/media/analytics-collapse-active.5d86ec0b.svg";